import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  DtpContentContainer,
  DtpNoContent,
  DtpTabGroup,
  DtpTab,
} from 'dtp-react-components';
import {
  Button,
} from '../../../../components/index';
import {
  doGet,
  doPut,
  trataMensagensErro,
  trataMensagemSucesso,
  requestPeriodosVigencia,
  requestOrgaosCentralizados,
  // requestRelEntidadesRppsUoInss,
  requestAbrangenciasEntidadeParticipanteRPPS,
  validateObject,
} from '../../../../utils/requests';
import ProtectedItem from '../../../../components/ComponentesAutenticacao/ProtectedItem';
import DadosRegimeProprio from './DadosRegimeProprio';
import OrgaosVinculados from './OrgaosVinculados';
import * as constantes from './../../../../utils/constants';
import validarCNPJ from '../../../../utils/validator/cnpjValidator';

const camposPreenchidosPorServicoCep = {
  enderecoRpps: [
    'municipio',
    'endereco',
    'ufRpps',
    'bairro',
  ],
};

class RegimeProprio extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
  }

  getInitialState = () => ({
    regimeProprio: {
      cnpjEf: null,
      nomeEf: null,
      ufEf: null,
      idParticipante: null,
      convenioTribunalContas: 0,
      tipoRegimeProprio: null,
      convenioComprev: 0,
      dataConvenio: null,
      cnpj: null,
      nomeRpps: null,
      sigla: null,
      telefone: null,
      enderecoEletronico: null,
      numeroBanco: null,
      numeroAgencia: null,
      dvAgencia: null,
      numeroContaCorrente: null,
      dvContaCorrente: null,
      cep: null,
      endereco: null,
      bairro: null,
      municipio: null,
      ufRpps: null,
      orgaosVinculados: [],
      idUOInssConvenio: null,
    },
    validadeCampos: {
      // enderecoEletronico: false,
      numeroBanco: false,
      numeroContaCorrente: false,
      orgaosVinculados: false,
      idUOInssConvenio: false,
      dataConvenio: false,
    },
    isTelefoneMovel: true,
    indicadorPesquisaComprev: false,
    exibirDataConvenio: false,
    touched: false,
    bancoTouched: false,
    nomeBanco: null,
    idUOInssConvenioTouched: false,
    nomeUOInssConvenio: null,
    emailTouched: false,
    acao: 'novo',
    estadoFormulario: 'inicial',
    camposOrgaosVinculadosInvalidos: null,
    showNoContent: false,
    noContentPrimaryMessage: 'Regime Próprio não encontrado para o cnpj informado.',
    noContentSecondaryMessage: 'Informe um protocolo válido.',
    requestPesquisa: null,
    showModalAlerta: false,
    chaveConfirmacao: null,
    situacao: null,
    listaOrgaosCentralizados: [],
    orgaoCentralizador: {
      codigo: null,
      nome: null,
      sigla: null,
    },
  });

  componentDidMount() {
    this.montaFormulario();
  }

  handleErrorBusca = (error) => {
    let mensagemPrimaria = 'Não foi possível consultar o regime próprio.';
    let mensagemSecundaria = 'Contate o administrador do sistema.';
    if (error) {
      if (error.status) {
        if (error.status === 404) {
          mensagemPrimaria = 'Ente  Federativo não encontrado para o filtro informado.';
          mensagemSecundaria = 'Informe um filtro válido.';
        }
      }
    }
    this.setState({
      showNoContent: true,
      noContentPrimaryMessage: mensagemPrimaria,
      noContentSecondaryMessage: mensagemSecundaria,
    });
  };

  handleErrorBuscaOrgaosCentralizados = (error) => {
    let mensagemPrimaria = 'Não foi possível consultar os orgãos centralizados.';
    let mensagemSecundaria = 'Contate o administrador do sistema.';
    if (error) {
      if (error.status) {
        if (error.status === 404) {
          mensagemPrimaria = 'Ente  Federativo não encontrado para o filtro informado.';
          mensagemSecundaria = 'Informe um filtro válido.';
        }
      }
    }
    this.setState({
      showNoContent: true,
      noContentPrimaryMessage: mensagemPrimaria,
      noContentSecondaryMessage: mensagemSecundaria,
    });
  };

  formularioProntoParaEnvio = () => (
    validateObject(this.state.validadeCampos)
  );

  buscaParticipanteRppsParaInclusao = () => {
    doGet(
      'participantes-rpps',
      this.handleSuccessBuscaDadosParticipanteRpps,
      this.handleErrorBusca,
      {
        idParticipante: this.props.match.params.codigo,
      },
    );
  }

  buscaParticipanteRppsLink = (codigo) => {
    const url = `participantes-rpps/codigo/${codigo}`;
    doGet(url, this.handleSuccessBuscaDadosParticipanteRpps, this.handleErrorBusca);
  }

  buscaParticipanteRpps = () => {
    const url = `participantes-rpps/codigo/${this.props.match.params.idParticipante}`;
    doGet(url, this.handleSuccessBuscaDadosParticipanteRpps, this.handleErrorBusca);
  }

  buscarOrgaosCentralizados = (codigo) => {
    requestOrgaosCentralizados(this.handleErrorBuscaOrgaosCentralizados, codigo);
  }

  buscarPeriodosVigenciaRegimesProprios = (codigo) => {
    requestPeriodosVigencia(this.handleErrorBusca, codigo);
  }

  buscarAbrangenciasEntidadeParticipanteRPPS = (codigo) => {
    requestAbrangenciasEntidadeParticipanteRPPS(this.handleErrorBusca, codigo);
  }

  montaSituacao = (regimeProprio) => {
    let situacao = '';
    if ((!regimeProprio.inExtinto) &&
      (!regimeProprio.inOrgaoCentralizado) &&
      (!regimeProprio.inOrgaoCentralizador)) {
      situacao = constantes.orgaoAtivo;
    } else if ((regimeProprio.inOrgaoCentralizador) && (regimeProprio.inOrgaoCentralizador === 1)) {
      situacao = constantes.orgaoCentralizador;
    } else if ((regimeProprio.inExtinto) && (regimeProprio.inExtinto === 1)) {
      situacao = constantes.orgaoExtinto;
    } else {
      situacao = constantes.orgaoAtivoCentralizado;
    }
    return situacao;
  }

  handleSuccessBuscaDadosParticipanteRpps = (response) => {
    const { orgaoCentralizador } = { ...this.state };
    const paramOrgaoCentralizador = orgaoCentralizador;
    const validadeCampos = this.montaValidadeCampos(response.data);
    let paramExibirDataConvenio = false;

    if (response.data.convenioComprev === 1) {
      paramExibirDataConvenio = true;
    }

    this.state.regimeProprio.idParticipante = response.data.codigo;
    this.state.regimeProprio.nomeEf = response.data.nome;
    this.state.regimeProprio.ufEf = response.data.uf;

    this.state.situacao = this.montaSituacao(response.data);

    if (this.state.situacao === constantes.orgaoCentralizador ||
      this.state.situacao === constantes.orgaoAtivo) {
      this.buscarOrgaosCentralizados(response.data.idParticipante);
    }
    if (response.data.participanteCompensacaoCentralizador) {
      if (this.state.situacao === constantes.orgaoAtivoCentralizado ||
        (this.state.situacao === constantes.orgaoExtinto)) {
        paramOrgaoCentralizador.codigo =
          response.data.participanteCompensacaoCentralizador.codigo;
        paramOrgaoCentralizador.nome =
          response.data.participanteCompensacaoCentralizador.nome;
        paramOrgaoCentralizador.sigla =
          response.data.participanteCompensacaoCentralizador.sigla;
      }
    }

    this.setState(
      {
        regimeProprio: { ...this.state.regimeProprio, ...response.data },
        exibirDataConvenio: paramExibirDataConvenio,
        orgaoCentralizador: paramOrgaoCentralizador,
        validadeCampos,
      },
      this.buscarAbrangenciasEntidadeParticipanteRPPS(response.data.idParticipante),
      this.buscarPeriodosVigenciaRegimesProprios(response.data.idParticipante),
    );

    const { regimeProprio } = { ...this.state };
    let bancoTouched = true;
    if (regimeProprio.numeroBanco && regimeProprio.numeroBanco !== null) {
      this.setState({ ...this.state, bancoTouched }, this.handleInstituicaoBancariaSemCriticas);
    }

    let idUOInssConvenioTouched = true;
    if (regimeProprio.inOrgaoUniao !== 1 &&
      regimeProprio.idUOInssConvenio &&
      regimeProprio.idUOInssConvenio !== null) {
      this.setState(
        { ...this.state, idUOInssConvenioTouched },
        this.handleIdUOInssConvenioSearch,
      );
    }

    let emailTouched = false;
    if (regimeProprio.enderecoEletronico && regimeProprio.enderecoEletronico !== null) {
      emailTouched = true;
      this.setState({ ...this.state, emailTouched });
    }

    let touched = true;
    if (regimeProprio.convenioComprev && regimeProprio.convenioComprev !== 0) {
      touched = true;
      this.setState({ ...this.state, touched });
    }

    this.verificarFormatacaoTelefone(regimeProprio);

    touched = false;
    bancoTouched = false;
    idUOInssConvenioTouched = false;

    this.setState({
      bancoTouched,
      idUOInssConvenioTouched,
      touched,
      emailTouched,
    });
  }

  montaFormulario = () => {
    this.setState(
      { acao: this.props.match.params.acao },
      this.buscaParticipanteRpps(),
    );
  }

  montaValidadeCampos = () => {
    const { validadeCampos } = { ...this.state };
    Object.keys(validadeCampos).forEach((key) => {
      validadeCampos[key] = true;
    });
    return validadeCampos;
  }

  handleChangeAptoConvenio = (changeObj, name, callback = null) => {
    const { regimeProprio } = { ...this.state };
    const { validadeCampos } = { ...this.state };
    let valor = 0;
    let paramExibirDataConvenio = false;

    if (changeObj.value === 1) {
      valor = 1;
      paramExibirDataConvenio = true;
    } else {
      Object.keys(validadeCampos).forEach((key) => {
        validadeCampos[key] = true;
      });
    }

    if (valor === 0 && regimeProprio.dataConvenio !== '') {
      validadeCampos.dataConvenio = true;
    }

    if (valor === 1) {
      if (regimeProprio.dataConvenio === '' || regimeProprio.dataConvenio === null) {
        validadeCampos.dataConvenio = false;
      }
      if ((regimeProprio.numeroBanco === '' || regimeProprio.numeroBanco === null) && regimeProprio.inOrgaoUniao === '0') {
        validadeCampos.numeroBanco = false;
      }
      if (regimeProprio.numeroContaCorrente === '' || regimeProprio.numeroContaCorrente === null) {
        validadeCampos.numeroContaCorrente = false;
      }
      if (regimeProprio.idUOInssConvenio === '' || regimeProprio.idUOInssConvenio === null) {
        validadeCampos.idUOInssConvenio = false;
      }
    }

    this.setState({
      exibirDataConvenio: paramExibirDataConvenio,
      regimeProprio: {
        ...regimeProprio,
        [name]: valor,
      },
      validadeCampos: {
        ...this.state.validadeCampos,
      },
    }, callback);
  }

  handleChange = (changeObj, name, callback = null) => {
    const { regimeProprio } = { ...this.state };

    if (name === 'numeroBanco' || name === 'numeroContaCorrente' ||
      name === 'orgaosVinculados' || name === 'idUOInssConvenio' ||
      name === 'dataConvenio') {
      this.setState({
        validadeCampos: {
          ...this.state.validadeCampos,
          [name]: changeObj.isValid,
        },
      });
    }
    if (name === 'idUOInssConvenio' && changeObj.value === '') {
      this.setState({
        nomeUOInssConvenio: '',
      });
    }
    this.setState({
      regimeProprio: {
        ...regimeProprio,
        [name]: changeObj.value,
      },
    }, callback);
  }

  handleChangeOrgaosVinculados = (changeObj, name) => {
    const { regimeProprio } = { ...this.state };
    this.setState({
      regimeProprio: {
        ...regimeProprio,
        [name]: changeObj,
      },
    });
  }

  trataSucessoResponseInstBancariaPesquisa = (response) => {
    const { validadeCampos } = { ...this.state };
    const regimeProprioAtual = this.state.regimeProprio;
    if (regimeProprioAtual.numeroBanco) {
      if (regimeProprioAtual.numeroBanco.length === 1) {
        regimeProprioAtual.numeroBanco = `00${regimeProprioAtual.numeroBanco}`;
      }
    }
    this.setState({
      regimeProprio: {
        ...regimeProprioAtual,
      },
      nomeBanco: response.data.nomeBanco,
      requestPesquisa: null,
      validadeCampos,
    });
  }

  handleInstituicaoBancariaSearch = () => {
    if (this.state.bancoTouched) {
      const { numeroBanco } = { ...this.state.regimeProprio };
      const { inOrgaoUniao } = { ...this.state.regimeProprio };

      if (inOrgaoUniao === 1 && (numeroBanco === null || numeroBanco === '000' || numeroBanco === '0' || numeroBanco === '00')) {
        const regimeProprioAtual = this.state.regimeProprio;
        if (regimeProprioAtual.numeroBanco) {
          if (regimeProprioAtual.numeroBanco.length < 3) {
            regimeProprioAtual.numeroBanco = '000';
          }
        }
        regimeProprioAtual.numeroAgencia = '0';
        regimeProprioAtual.dvAgencia = '0';
        regimeProprioAtual.numeroContaCorrente = '0';
        regimeProprioAtual.dvContaCorrente = '0';
        regimeProprioAtual.nomeBanco = '';
        this.setState({
          regimeProprio: {
            ...regimeProprioAtual,
          },
          nomeBanco: '',
          requestPesquisa: null,
        });
      } else {
        this.setState(
          { requestPesquisa: 'instituicaoBancaria' },
          doGet(
            `instituicao-bancaria/${numeroBanco}`,
            this.trataSucessoResponseInstBancariaPesquisa,
            this.trataErrosResponse,
          ),
        );
      }
    }
  }

  // necessario porque o banco de dados nao grava o nome da inst bancaria
  // e isso é carregado ao renderizar a pag,
  // nao deve haver criticas caso seja um orgao da uniao (pois pode existir banco zerado),
  // porem permitir buscar do sdc mesmo sendo orgao da uniao
  handleInstituicaoBancariaSemCriticas = () => {
    if (this.state.bancoTouched) {
      const { numeroBanco } = { ...this.state.regimeProprio };
      const { inOrgaoUniao } = { ...this.state.regimeProprio };

      if (inOrgaoUniao === 1 && (numeroBanco === null || numeroBanco === '000' || numeroBanco === '0' || numeroBanco === '00')) {
        this.state.regimeProprio.numeroBanco = '000';
        this.state.regimeProprio.nomeBanco = '';
      } else {
        this.setState(
          { requestPesquisa: 'instituicaoBancaria' },
          doGet(
            `instituicao-bancaria/${numeroBanco}`,
            this.trataSucessoResponseInstBancariaPesquisa,
          ),
        );
      }
    }
  }

  trataSucessoResponseIdUOInssConvenio = (response) => {
    const { validadeCampos } = { ...this.state };
    const regimeProprioAtual = this.state.regimeProprio;
    validadeCampos.idUOInssConvenio = true;
    this.setState({
      regimeProprio: {
        ...regimeProprioAtual,
      },
      nomeUOInssConvenio: response.data.nomeUnidade,
      requestPesquisa: null,
      validadeCampos,
    });
  }

  handleIdUOInssConvenioSearch = () => {
    if (this.state.idUOInssConvenioTouched) {
      const { idUOInssConvenio } = { ...this.state.regimeProprio };
      this.setState(
        { requestPesquisa: 'idUOInssConvenio' },
        doGet(
          `uo-inss/${idUOInssConvenio}`,
          this.trataSucessoResponseIdUOInssConvenio,
          this.trataErrosResponse,
        ),
      );
    }
  }

  handleBlur = () => {
    const { regimeProprio } = { ...this.state };
    const { validadeCampos } = { ...this.state };
    let bancoTouched = false;

    if (regimeProprio.dvAgencia) {
      const paramDvAgencia = regimeProprio.dvAgencia.toUpperCase();
      regimeProprio.dvAgencia = paramDvAgencia;
    }

    if (regimeProprio.dvContaCorrente) {
      const paramDvContaCorrente = regimeProprio.dvContaCorrente.toUpperCase();
      regimeProprio.dvContaCorrente = paramDvContaCorrente;
    }

    this.setState({
      regimeProprio: {
        ...regimeProprio,
      },
      validadeCampos: {
        ...validadeCampos,
      },
    });
    if (regimeProprio.numeroBanco) {
      if (regimeProprio.numeroBanco.length < 4) {
        bancoTouched = true;
        this.setState({ ...this.state, bancoTouched }, this.handleInstituicaoBancariaSearch);
      }
    }
  }

  handleBlurIdUOInssConvenio = () => {
    const { regimeProprio } = { ...this.state };
    let idUOInssConvenioTouched = false;
    if (regimeProprio.idUOInssConvenio) {
      idUOInssConvenioTouched = true;
      this.setState({ ...this.state, idUOInssConvenioTouched }, this.handleIdUOInssConvenioSearch);
    }
  }

  verificarFormatacaoTelefone = (regimeProprio) => {
    let { isTelefoneMovel } = { ...this.state };

    if (regimeProprio.telefone && (regimeProprio.telefone !== '' && regimeProprio.telefone !== null)) {
      const tel = regimeProprio.telefone.trim();
      let telaux = '';
      telaux = tel.replace(/[^0-9,]*/g, '');

      if (telaux.length === 10) { // é fixo
        const paramIsTelefoneMovel = false;
        isTelefoneMovel = paramIsTelefoneMovel;
      } else {
        isTelefoneMovel = true;
      }
    }
    this.setState({ ...this.state, isTelefoneMovel });
  }

  handleBlurTelefone = () => {
    const { regimeProprio } = { ...this.state };
    let { isTelefoneMovel } = { ...this.state };

    if (regimeProprio.telefone &&
      (regimeProprio.telefone !== '' && regimeProprio.telefone !== null)) {
      if (regimeProprio.telefone.length === 10) { // é movel
        const paramIsTelefoneMovel = false;
        isTelefoneMovel = paramIsTelefoneMovel;
      } else {
        isTelefoneMovel = true;
      }
    }
    this.setState({ ...this.state, isTelefoneMovel });
  }

  handleBlurDigitoVerificador = () => {
    const { regimeProprio } = { ...this.state };
    const { validadeCampos } = { ...this.state };

    if (regimeProprio.dvAgencia) {
      const dvAgencia = regimeProprio.dvAgencia.toUpperCase();
      regimeProprio.dvAgencia = dvAgencia;
    }
    if (regimeProprio.dvContaCorrente) {
      const dvContaCorrente = regimeProprio.dvContaCorrente.toUpperCase();
      regimeProprio.dvContaCorrente = dvContaCorrente;
    }
    this.setState({
      regimeProprio: {
        ...regimeProprio,
      },
      validadeCampos: {
        ...validadeCampos,
      },
    });
  }

  validacaoErrosOrgaoVinculado = (errosOrgaoVinculado) => {
    let camposInvalidos = null;
    // if (isDelete) {
    //   camposInvalidos = errosOrgaoVinculado;
    // } else {
    camposInvalidos =
      this.state.camposOrgaosVinculadosInvalidos.filter(erro =>
        (errosOrgaoVinculado.includes(erro) ? null : erro));
    // }
    this.setState({ camposOrgaosVinculadosInvalidos: camposInvalidos });
  }

  handleCadPrevSearch = () => {
    const { cnpjEf } = { ...this.state.regimeProprio };
    this.setState(
      { requestPesquisa: 'cadprev' },
      doGet(
        `cadprev/${cnpjEf}`,
        this.trataSucessoResponseCadPrevPesquisa,
        this.trataErrosResponse,
      ),
    );
  }

  handleSearchCadPrevButton = () => {
    this.setState(this.handleCadPrevSearch);
  }

  /**
   * Trata o click no botão de busca por CPF no CNIS.
   */
  handleSearchCepButton = () => {
    const cepTouched = true;
    this.setState({ ...this.state, cepTouched }, this.handleCepSearch);
  }

  handleCepSearch = () => {
    if (this.state.validadeCampos.cep) {
      const { cep } = { ...this.state.regimeProprio };
      this.setState(
        { requestPesquisa: 'enderecoRpps' },
        doGet(
          `cep/${cep}`,
          this.trataSucessoResponseCepPesquisa,
          this.trataErrosResponse,
        ),
      );
    }
  }

  trataSucessoResponseCepPesquisa = (response) => {
    const { validadeCampos } = { ...this.state };
    const regimeProprioAtual = this.state.regimeProprio;
    camposPreenchidosPorServicoCep[this.state.requestPesquisa].forEach((key) => {
      validadeCampos[key] = true;
    });

    regimeProprioAtual.endereco = `${response.data.tipoLogradouro}. ${response.data.descricao}`;
    regimeProprioAtual.municipio = response.data.codigoMunicipioPrev;
    regimeProprioAtual.bairro = response.data.nomeBairro;
    regimeProprioAtual.ufRpps = response.data.siglaUf;

    this.setState({
      regimeProprio: {
        ...regimeProprioAtual,
      },
      requestPesquisa: null,
      validadeCampos,
    });
  }

  /**
   * Trata os erros nas requisicoes (busca e submissao de formulario)
   */
  trataErrosResponse = (error) => {
    const { validadeCampos } = { ...this.state };
    const { regimeProprio } = { ...this.state };
    if (error && error.data && error.data.tipo === 2) {
      const { data } = { ...error };
      this.setState({
        chaveConfirmacao: data.chaveConfirmacao,
        alertas: data.alertas,
        showModalAlerta: !this.state.showModalAlerta,
      });
    } else {
      if (this.state.requestPesquisa) {
        switch (this.state.requestPesquisa) {
          case 'enderecoRpps':
            camposPreenchidosPorServicoCep[this.state.requestPesquisa].forEach((key) => {
              validadeCampos[key] = false;
              regimeProprio[key] = '';
            });
            trataMensagensErro(['CEP inválido. Informe um CEP válido.']);
            break;
          case 'instituicaoBancaria':
            this.setState({
              nomeBanco: '',
            });
            trataMensagensErro(['Código do banco inválido. Informe um código de banco válido.']);
            break;
          case 'idUOInssConvenio':
            this.setState({
              nomeUOInssConvenio: '',
            });
            trataMensagensErro(['Código da UO inválido. Informe um código de UO válido.']);
            break;
          case 'cadprev':
            trataMensagensErro(['Não foi possível se comunicar com o serviço CADPREV.']);
            break;
          default: trataMensagensErro(['Houve um erro na tentativa de se comunicar com o serviço. Por favor, tente novamente mais tarde.']);
        }
      }
      if (error) {
        const { data } = { ...error };
        if (error.status === 400) {
          const camposOrgaosVinculadosInvalidos = [];
          if (data.erros && data.erros.length >= 1) {
            data.erros.forEach((erro) => {
              if (erro.atributo in validadeCampos) {
                validadeCampos[[erro.atributo]] = false;
              }
              // eslint-disable-next-line
              if (erro.hasOwnProperty('indiceLista')) {
                camposOrgaosVinculadosInvalidos.push(erro);
                validadeCampos.orgaosVinculados = false;
              }
            });
            this.setState({
              ...this.state, validadeCampos, camposOrgaosVinculadosInvalidos, estadoFormulario: 'erro-regra',
            });
          }
        }
      }
    }
  }

  formularioRegimeProprio = () => (
    <DadosRegimeProprio
      acao={this.state.acao}
      estadoFormulario={this.state}
      handleChange={this.handleChange}
      handleChangeAptoConvenio={this.handleChangeAptoConvenio}
      handleKeyUp={this.handleKeyUp}
      handleBlur={this.handleBlur}
      handleBlurDigitoVerificador={this.handleBlurDigitoVerificador}
      handleBlurIdUOInssConvenio={this.handleBlurIdUOInssConvenio}
      match={this.props.match}
      periodosVigencia={this.props.periodosVigencia}
      orgaosCentralizados={this.props.orgaosCentralizados}
      handleCadPrevSearch={this.handleCadPrevSearch}
      auth={this.props.auth}
      // handleSearchCepButton={this.handleSearchCepButton}
      // handleBlurTelefone={this.handleBlurTelefone}
      abrangenciasEntidadeParticipanteRPPS={this.props.abrangenciasEntidadeParticipanteRPPS}
      buscaParticipanteRpps={this.buscaParticipanteRppsLink}
      handleSuccessBuscaDadosParticipanteRpps={this.handleSuccessBuscaDadosParticipanteRpps}
      handleErrorBusca={this.handleErrorBusca}
    />
  );

  montaCorpoCadastro = () => {
    const corpoRequerimento = (
      <DtpTabGroup className="dtp-default">
        {this.montaTabs()}
      </DtpTabGroup>
    );
    return corpoRequerimento;
  }

  tabFormulario = () => (
    <DtpTab id="item1" className="active" title="Dados básicos">
      {this.formularioRegimeProprio()}
    </DtpTab>
  );

  tabListaOrgaosVinculados = () => (
    <DtpTab id="item2" title="Orgãos Vinculados">
      <OrgaosVinculados
        acao={this.state.acao}
        estadoFormulario={this.state}
        orgaosVinculados={[...this.state.regimeProprio.orgaosVinculados]}
        // orgaosVinculados={[...this.props.abrangenciasEntidadeParticipanteRPPS]}
        handleChange={this.handleChange}
        handleChangeOrgaosVinculados={this.handleChangeOrgaosVinculados}
        auth={this.props.auth}
      />
    </DtpTab>
  )

  montaTabs = () => {
    const listaTabs = [];
    listaTabs.push(this.tabFormulario());
    // if (this.state.regimeProprio.orgaosVinculados &&
    //   this.state.regimeProprio.orgaosVinculados.length > 0) {
    if ((this.state.regimeProprio.inOrgaoUniao === undefined) ||
      (this.state.regimeProprio.inOrgaoUniao !== undefined && this.state.regimeProprio.inOrgaoUniao === 0)) {
      listaTabs.push(this.tabListaOrgaosVinculados());
    }
    return listaTabs;
  }

  /**
  * Trata o click do botao de submissao do formulario
  * Se analise estiver indeferindo, exibir alerta de confirmacao
  */
  handleSaveButton = () => {
    this.confirmSendData();
  }
  /**
  * Trata envio dos dados
  */
  confirmSendData = () => {
    const cnpjValido = validarCNPJ(this.state.regimeProprio.cnpj);
    if (!cnpjValido) {
      trataMensagensErro(['CNPJ Inválido. Informe um CNPJ válido.']);
      return;
    }
    const touched = true;
    const url = 'participantes-compensacao';

    const { validadeCampos } = { ...this.state };
    Object.keys(validadeCampos).forEach((key) => {
      validadeCampos[key] = true;
    });

    this.setState({
      touched,
      validadeCampos,
      requestPesquisa: null,
    }, () => this.handleSave(url));
  }

  handleSave = (url) => {
    if (this.formularioProntoParaEnvio()) {
      let options;
      if (this.state.chaveConfirmacao) {
        options = { 'Chave-Confirmacao': this.state.chaveConfirmacao };
      }
      const { regimeProprio } = { ...this.state };
      regimeProprio.periodosVigencia = this.props.periodosVigencia;

      // Alteração necessária para apagar a data do
      // convênio somente quando for salvar os dados do participante
      if (regimeProprio.convenioComprev === 0) {
        regimeProprio.dataConvenio = '';
      }

      if (regimeProprio.orgaosVinculados &&
        regimeProprio.orgaosVinculados.length > 0) {
        const colecao = [];
        regimeProprio.orgaosVinculados.forEach((orgao) => {
          if (orgao.flagOperacao) {
            colecao.push(orgao);
          }
        });

        if (colecao.length > 0) {
          regimeProprio.orgaosVinculados = colecao;
        } else {
          // não alterou e nem incluiu orgao vinculado
          const listaOrgaosVinculadosAux = [];
          regimeProprio.orgaosVinculados.map((item, i) => {
            const itemIndexado = item;
            itemIndexado.contador = i;

            if (i <= 5) {
              listaOrgaosVinculadosAux.push(itemIndexado);
            }
            return listaOrgaosVinculadosAux;
          });
          regimeProprio.orgaosVinculados = [];
          regimeProprio.orgaosVinculados = listaOrgaosVinculadosAux;
        }
      }

      doPut(
        url,
        regimeProprio,
        this.trataSucessoResponseEnvio,
        this.trataErrosResponse,
        options,
      );
    } else {
      trataMensagensErro(['Informe corretamente os atributos indicados na tela.']);
    }
  }

  trataSucesso = () => {
    const mensagemSucesso = 'Ente Federativo atualizado.';
    // this.props.history.goBack();
    this.montaFormulario();
    this.setState({
      estadoFormulario: 'criado',
    });
    trataMensagemSucesso([mensagemSucesso]);
  }

  /**
   * Trata as respostas positivas em caso de submissao de formulario (POST, PUT)
   */
  trataSucessoResponseEnvio = () => {
    if (this.state.chaveConfirmacao) {
      this.setState({
        chaveConfirmacao: null,
        alertas: [],
        showModalAlerta: !this.state.showModalAlerta,
      }, this.trataSucesso);
    } else {
      this.trataSucesso();
    }
  }

  render() {
    if (this.state.reset) {
      return null;
    }

    if (this.state.showNoContent) {
      return (
        <DtpNoContent
          primaryText={this.state.noContentPrimaryMessage}
          secondaryText={this.state.noContentSecondaryMessage}
          show={this.state.showNoContent}
        />);
    }

    let botaoAcaoPrincipal;

    const configBotaoPrincipal = {
      onClick: this.handleSaveButton,
    };

    configBotaoPrincipal.permissoes = ['analisar-negocio-sprev'];
    configBotaoPrincipal.titulo = 'Salvar';
    configBotaoPrincipal.hint = 'Salvar Regime Próprio';
    const botaoAcaoVoltar = (
      <Button
        className="left"
        onClick={this.props.history.goBack}
        title="Voltar"
        hint="Voltar para tela anterior"
      />
    );

    if (configBotaoPrincipal.titulo) {
      botaoAcaoPrincipal = (
        <ProtectedItem allowedPermissions={configBotaoPrincipal.permissoes}>
          <Button
            className="dtp-primary right"
            disabled={!this.formularioProntoParaEnvio()}
            title={configBotaoPrincipal.titulo}
            onClick={configBotaoPrincipal.onClick}
            hint={configBotaoPrincipal.hint}
          />
        </ProtectedItem>
      );
    }

    const retorno = (
      <DtpContentContainer>
        {/* {this.formularioRegimeProprio()} */}
        {this.montaCorpoCadastro()}
        <div className="row">
          {botaoAcaoVoltar}
          {botaoAcaoPrincipal}
        </div>
      </DtpContentContainer>
    );
    return retorno;
  }
}

RegimeProprio.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      idParticipante: PropTypes.string,
      acao: PropTypes.string,
      codigo: PropTypes.string,
    }),
  }),
  history: PropTypes.shape({
    goBack: PropTypes.function,
  }).isRequired,
  auth: PropTypes.shape({
    userData: PropTypes.object,
    checkPermission: PropTypes.func,
  }),
  periodosVigencia: PropTypes.arrayOf(PropTypes.shape({
    cnpj: PropTypes.string,
    dataCriacaoRpps: PropTypes.string,
    dataEncerramentoRpps: PropTypes.string,
  })),
  orgaosCentralizados: PropTypes.arrayOf(PropTypes.shape({
    codigo: PropTypes.string,
    nome: PropTypes.string,
  })),
  abrangenciasEntidadeParticipanteRPPS: PropTypes.arrayOf(PropTypes.shape({
    cnpj: PropTypes.string,
    idParticipante: PropTypes.string,
    nomeOrgaoVinculado: PropTypes.string,
    situacao: PropTypes.string,
  })),
};

RegimeProprio.defaultProps = {
  match: null,
  auth: null,
  periodosVigencia: [],
  orgaosCentralizados: [],
  abrangenciasEntidadeParticipanteRPPS: [],
};

const mapStateToProps = state => ({
  periodosVigencia: state.base.periodosVigencia,
  orgaosCentralizados: state.base.orgaosCentralizados,
  abrangenciasEntidadeParticipanteRPPS: state.base.abrangenciasEntidadeParticipanteRPPS,
});

export default connect(mapStateToProps)(RegimeProprio);



// WEBPACK FOOTER //
// ./src/pages/cadastros/EntesFederativos/Rpps/RegimeProprio.jsx